module.exports = __webpack_public_path__ + "media/v-pre.3c2d1d98.mp4";